export class PasswordValidator {
    constructor(policy, commonPasswords = []) {
        this.policy = policy;
        this.commonPasswords = new Set(commonPasswords.map(p => p.toLowerCase()));
    }

    static async create() {
        const res = await fetch("/company/idpsettings");
        const data = await res.json();

        return new PasswordValidator(data.passwordPolicy, data.passwordPolicy.CommonPasswords || []);
    }

    validate(password) {
        let result = {
            valid: true,
            error: ""
        };

        if (this.policy.enabled) {
            if (password.length < this.policy.minLength)
                result = { valid: false, error: this.getInvalidMessage() };

            if (this.policy.requireUppercase && !/[A-Z]/.test(password))
                result = { valid: false, error: this.getInvalidMessage() };

            if (this.policy.requireLowercase && !/[a-z]/.test(password))
                result = { valid: false, error: this.getInvalidMessage() };

            if (this.policy.requireDigit && !/[0-9]/.test(password))
                result = { valid: false, error: this.getInvalidMessage() };

            if (this.policy.requireSpecial && !/[^A-Za-z0-9]/.test(password))
                result = { valid: false, error: this.getInvalidMessage() };

            if (this.policy.banCommonPasswords && this.commonPasswords.has(password.toLowerCase()))
                result = { valid: false, error: this.getInvalidMessage() };
        }

        return result;
    }

    getInvalidMessage() {
        const rules = [];

        if (this.policy.minLength)
            rules.push(`at least be ${this.policy.minLength} characters long`);

        if (this.policy.requireUppercase)
            rules.push("contain an uppercase letter");

        if (this.policy.requireLowercase)
            rules.push("contain a lowercase letter");

        if (this.policy.requireDigit)
            rules.push("contain a number");

        if (this.policy.requireSpecial)
            rules.push("contain a special character (e.g. !@#$%)");

        if (this.policy.banCommonPasswords)
            rules.push("not be a commonly used password");

        return "Password must " + rules.join(", ") + ".";
    }
}